import clsx from "clsx";
import { Children, cloneElement, useContext, useState } from "react";
import { ClassroomContext } from "../classroom.context";

export function Select({
  name = "",
  required = true,
  horizontal = false,
  multiple,
  onChange,
  children,
}) {
  const {
    form: { touched },
    getField,
    setField,
  } = useContext(ClassroomContext);

  const [value, setValue] = useState(getField(name) || []);

  const onSelect = (event) => {
    let newValue;
    if (multiple) {
      if (event.target.checked) {
        newValue = [...value, event.target.value].sort();
      } else {
        newValue = value.filter((el) => el !== event.target.value);
      }
    } else {
      newValue = [event.target.value];
    }
    setValue(newValue);
    onChange?.(multiple ? newValue : newValue[0] || "");
    if (!name) {
      return;
    }
    setField(name, newValue);
  };

  return (
    <div
      className={clsx(
        "option-group",
        horizontal && "option-group-horizontal",
        required && touched[name] && !value.length && "option-group_error",
      )}
    >
      {Children.map(children, (child) => {
        const selected =
          value.includes(child.props.description?.toString()) ||
          value.includes(child.props.value?.toString())
            ? "selected"
            : "";
        return cloneElement(child, {
          key: child.props.description,
          name,
          type: multiple ? "checkbox" : "radio",
          selected,
          onSelect,
        });
      })}
    </div>
  );
}
